export const environment = {
  production: true,
  apiUrl: 'https://woori-mart.co.kr/api/',
  fileUrl: 'https://woori-mart.co.kr/assets/'
};
